import TeammateDetail from "./TeammateDetail";

export default function SingleTeammate() {
  return <TeammateDetail />;
}
